<button
  type="button"
  class="ntt-dropdown-menu-item"
  [class.ntt-dropdown-menu-item--disabled]="isBlocked()"
  [disabled]="isBlocked()"
  [attr.aria-busy]="loading()"
  (click)="_onClick()"
>
  <div class="ntt-dropdown-menu-item__content">
    <div class="ntt-dropdown-menu-item__text-wrapper">
      @if (loading()) {
        <ntt-spinner class="ntt-dropdown-menu-item__spinner" size="sm" />
      } @else if (hasIcon()) {
        <i class="ntt-dropdown-menu-item__icon" [class]="'icon-' + icon()"></i>
      }
      <span class="ntt-dropdown-menu-item__label text-sm-bold">{{
        label()
      }}</span>
    </div>
    @if (hasShortcut()) {
      <div class="ntt-dropdown-menu-item__shortcut">
        <span class="flip-direction text-xs-semi-bold">{{ shortcut() }}</span>
      </div>
    }
  </div>
</button>
